import React from 'react'
import { Breadcrumb } from 'react-breadcrumbs'
import { withRouter } from 'react-router-dom'

import { PATHS } from 'Config/Routing/paths'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { CitiesWrapper } from 'Components/City'
import { CityPageContext } from 'Components/City/Page/Context'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { PageTitle } from 'Components/PageTitle'
import { CityHeaderNav } from 'Containers/City/Page/HeaderNav'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import CitiesIcon from 'Assets/Images/icons/cities'
import WarningLabel from '../../../Components/WarningLabel/WarningLabel'

const CityPage = props => {
  const {
    cityName,
    newcomersMissionsLimit,
    recruitmentOnHold,
    className,
  } = props

  return (
    <CitiesWrapper className={className}>
      <WarningLabel
        visible={newcomersMissionsLimit}
        message={`
        First week blocker feature enabled! Capped at ${newcomersMissionsLimit} missions!`}
      />
      <WarningLabel
        visible={recruitmentOnHold}
        message={'Recruitment is on pause'}
      />
      <LayoutDashboard>
        <Breadcrumbs icon={<CitiesIcon style={{ width: 24 }} />} />
        <Breadcrumb
          data={{
            title: 'Cities',
            pathname: PATHS.main.dashboard + PATHS.dashboard.cities,
          }}
        />
        <Breadcrumb
          data={{
            title: cityName,
            pathname: PATHS.main.dashboard + PATHS.dashboard.cities,
          }}
        />
        <PageTitle>{cityName}</PageTitle>
      </LayoutDashboard>
      <CityPageContext>
        <CityHeaderNav
          active={props.active}
          cityId={props.cityId}
          history={props.history}
          match={props.match}
        />
        <HideWhenBlocked>{props.children}</HideWhenBlocked>
      </CityPageContext>
    </CitiesWrapper>
  )
}

export default withRouter(CityPage)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/index.js